<template>
  <EmailList :type="1" :group="true"/>
</template>
<script setup>
import {useRoute} from "vue-router";
import EmailList from "@/views/components/EmailList/EmailList.vue";

const route = useRoute()
</script>